<tax-modal-header>tariffs.subscribe.select.modal</tax-modal-header>

<tax-modal-content>
  <tax-vertical-tariff-list
    *ngIf="!selectedTariff && tariffs.length"
    [tariffs]="tariffs | uniqueTariffs"
    (emitSelectedTariff)="selectTariff($event)"
  ></tax-vertical-tariff-list>

  <ng-container *ngIf="selectedTariff">
    <tax-vertical-tariff-list
      [tariffs]="$any([selectedTariff])"
      [selectedTariff]="selectedTariff"
    ></tax-vertical-tariff-list>
    <tax-select-tariff-connection
      [kkmProcessFields]="kkmProcessFields"
      class="tariff-connection-form"
      (formChanges)="updateFormState($event)"
    ></tax-select-tariff-connection>
  </ng-container>
</tax-modal-content>

<tax-modal-footer *ngIf="selectedTariff" class="modal-footer">
  <button class="back-button" data-qa-button="go-back" (click)="back()">
    {{ 'button.back' | translate }}
  </button>

  <button
    class="button_blue"
    data-qa-button="save-kkm-tariff"
    [disabled]="!tariffForm || tariffForm?.invalid"
    (click)="returnSelectedTariff()"
  >
    {{ 'button.continue' | translate }}
  </button>
</tax-modal-footer>
